import styled from "@emotion/styled";

const Stepper = styled.div`
  display: flex;
  gap: 8px;
  align-self: center;
`;

const Step = styled.span`
  display: inline-block;
  width: 48px;
  height: 8px;
  background-color: #e9e9e9;
  cursor: pointer;
  border-radius: 25px;

  &.active {
    background-color: #00b0b9;
  }

  &.disable {
    pointer-events: none;
    cursor: not-allowed;
  }
`;

export function Steppers({ activeStep, onClick, steps }) {
  return (
    <Stepper>
      {steps.map((_, index) => (
        <Step
          key={index}
          className={
            activeStep === index
              ? "active"
              : activeStep < index
              ? "disable"
              : ""
          }
          onClick={() => onClick(index)}
        />
      ))}
    </Stepper>
  );
}
